export const EVENT_KEY = "nbaa-bace-2026";
export const IRONFLEET_BOOTH = "952";
export const DEFAULT_NEAREST_LIMIT = 10;

/** Matches classification.segment_primary (SEGMENT_PRIMARY_VALUES in mkt-intel-mcp). */
export const SEGMENT_PRIMARY_VALUES = [
  "Part 145",
  "Part 91",
  "Part 135",
  "Supplier",
  "Parts Provider",
  "OEM_Service",
  "Software and Services Provider",
  "Media",
  "Social Media",
  "Competitor",
  "Customer",
  "Investor",
  "Partner",
  "FBO",
  "School",
  "NonICP",
  "Other",
] as const;

export type SegmentPrimary = (typeof SEGMENT_PRIMARY_VALUES)[number];

export const SEGMENT_PRIMARY_FILTER_TOP = [
  "Part 145",
  "Part 91",
  "Part 135",
  "Supplier",
  "Parts Provider",
] as const satisfies readonly SegmentPrimary[];

export const SEGMENT_PRIMARY_FILTER_MORE = SEGMENT_PRIMARY_VALUES.filter(
  (value) => !(SEGMENT_PRIMARY_FILTER_TOP as readonly string[]).includes(value),
);

/** Compact labels still stored by live intel until the Part-space datafix lands. */
const SEGMENT_PRIMARY_COMPACT: Record<string, SegmentPrimary> = {
  Part145: "Part 145",
  Part91: "Part 91",
  Part135: "Part 135",
};

export function canonicalSegmentPrimaryLabel(value: string): string {
  const trimmed = value.trim();
  return SEGMENT_PRIMARY_COMPACT[trimmed] ?? trimmed;
}

export function segmentsMatch(rowSegment: string | null | undefined, wanted: string): boolean {
  if (!rowSegment) return false;
  return canonicalSegmentPrimaryLabel(rowSegment).toLowerCase() === canonicalSegmentPrimaryLabel(wanted).toLowerCase();
}

export const CAMPAIGNS = [{ key: EVENT_KEY, label: "NBAA BACE 2026" }] as const;
export const DEFAULT_CAMPAIGN_KEY = CAMPAIGNS[0].key;

/** Search bar hints for the full CRM roster (not exhibitor-only). Update when ingest totals change. */
export const ROSTER_SEARCH_HINT = {
  accounts: 2607,
  contacts: 11_842,
} as const;

export function formatRosterSearchPlaceholder(noun: string, count: number): string {
  const formatted = count.toLocaleString("en-US");
  return `Search ${formatted} ${noun} ...`;
}

const USER_ID_KEY = "ironfleet-walker:user-id";
const DISPLAY_NAME_KEY = "ironfleet-walker:display-name";

function randomId(): string {
  if (typeof crypto !== "undefined" && "randomUUID" in crypto) {
    return crypto.randomUUID();
  }
  return `u-${Date.now()}-${Math.random().toString(36).slice(2, 10)}`;
}

/** Stable per-device identity for check-in/presence; created once, kept in localStorage. */
export function getOrCreateUserId(): string {
  try {
    const existing = localStorage.getItem(USER_ID_KEY);
    if (existing) return existing;
    const created = randomId();
    localStorage.setItem(USER_ID_KEY, created);
    return created;
  } catch {
    return randomId();
  }
}

export function getStoredDisplayName(): string {
  try {
    return localStorage.getItem(DISPLAY_NAME_KEY) ?? "";
  } catch {
    return "";
  }
}

export function setStoredDisplayName(name: string): void {
  try {
    localStorage.setItem(DISPLAY_NAME_KEY, name);
  } catch {
    // Storage unavailable (private mode, etc.) â€” fine to no-op.
  }
}
